import { __decorate, __metadata } from "tslib";
import { IsString } from 'class-validator';
/**
 * The request is used in both:
 * - The request to enable MFA for a user.
 * - The request to replace the MFA device for a user.
 */
export class VerifyMultifactorAuthenticationDeviceBody {
    /**
     * @param accessToken A valid access token that Amazon Cognito issued to the user whose software token you want to verify
     * @param userCode The one- time password computed using the secret code returned by AssociateSoftwareToken.
     */
    constructor(accessToken, userCode) {
        this.accessToken = accessToken;
        this.userCode = userCode;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], VerifyMultifactorAuthenticationDeviceBody.prototype, "accessToken", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], VerifyMultifactorAuthenticationDeviceBody.prototype, "userCode", void 0);
